import template from './parking-places-count.jade';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.commonParkingPlacesCount', [])
  .directive('cianAfCommonParkingPlacesCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.countMax = 999;
        this.countMin = 1;

        this.validation = validation(this.form, 'building.parking.placesCount', {
          parse: 'Введите число',
          max: 'Допустимо не более 3 символов',
          min: 'Введите число',
        });
      },
    ],
    controllerAs: 'parkingPlacesCount',
    template,
  })).name;
